export const messages = {
  title: 'Surveys',
  activateError: 'Unable to activate survey. Please try again later.',
  activateSuccess: 'Survey was activated',
  archiveError: 'Unable to archive survey. Please try again later.',
  archiveSuccess: 'Survey was archived',
  configurePageTitle: 'General Survey',
  subtitle: 'Learn more about your members',
};
